import React from "react";
import { DefaultContextValue } from "@hex-insights/core";
import { UserAndUserGroupListForMessagesQuery } from "../../../../../Utilities";

export type MessageGroupCreateContextValue = {
	selectedUserRecipients: UserAndUserGroupListForMessagesQuery["userConnection"]["edges"][0]["node"][];
	selectedUserGroupRecipients: UserAndUserGroupListForMessagesQuery["userGroupConnection"]["edges"][0]["node"][];
};

export const MessageGroupCreateContext = React.createContext<MessageGroupCreateContextValue>(
	new DefaultContextValue("MessageGroupCreateContext") as any,
);
